import type { StandardDialogProps } from "@win-reality/react-ui";
import { Dialog } from "@win-reality/react-ui";

import { useTaggingTheme } from "../hooks/useTaggingTheme";

type ThemedDialogProps = Omit<StandardDialogProps, "variant">;

/** react-ui Dialog in the tagging theme's light/dark variant. */
export const ThemedDialog = (props: ThemedDialogProps) => {
  const { theme } = useTaggingTheme();
  return <Dialog {...props} variant={theme} />;
};
